import type {
  ProductCollectionSitemapQueryVariables,
  ProductCollectionSitemapQuery,
} from 'src/types';
import query from '../query.graphql';
import { usePageQuery } from 'src/hooks/use-page-query';

export function useProductCollectionSitemapPageQuery(
  variables: ProductCollectionSitemapQueryVariables
) {
  return usePageQuery<ProductCollectionSitemapQuery>({
    query,
    routeName: 'productCollectionSitemap',
    variables,
  });
}
